import React from "react";
import { H4 } from "components/core/Typography";
import SearchBar from "components/search/SearchBar/SearchBar";
import "./StickySearchbar.scss";

function StickySearchbar() {
	return (
		<div className="sticky-searchbar-container">
			<SearchBar
				buttonText="Find Storage"
				id="hero-search-bar"
				label="Search by zip"
				theme="stickyDarkBlue"
				className="sticky-searchbar"
			>
				<H4
					weight="bold"
					size="xxlarge"
					largeSize="large"
					align="center"
					color="white"
				>
					Find Cheap Storage Units Near You
				</H4>
			</SearchBar>
		</div>
	);
}

export default StickySearchbar;
